import React, { ReactElement } from "react";
import { ReversingLabsLogo, Toast } from "@sscs/ui";
import { checkIsDemoPortal } from "Utils";
import styles from "./loginLayout.module.scss";
import MailToSupportLink from "./MailToSupportLink";
import RegisterUserLink from "./RegisterUserLink";

const IS_DEMO_PORTAL = checkIsDemoPortal();

type LoginLayoutProps = {
  children: ReactElement | ReactElement[];
  isDemoPortal?: boolean;
};

const LoginLayout = ({
  children,
  isDemoPortal = IS_DEMO_PORTAL,
}: LoginLayoutProps): React.JSX.Element => {
  return (
    <div className={styles.root}>
      <div className={styles["layout-wrapper"]}>
        <div className={styles["grid-container"]}>
          <div className={styles["grid-col"]}>
            <div className={styles["left-box"]}>
              <div className={styles["logo-wrapper"]}>
                <h1 className={styles["logo-heading"]}>
                  <ReversingLabsLogo className={styles.logo} />
                  <span className={styles.wordmark}>Spectra Assure</span>
                </h1>
                <p className={styles.tagline}>
                  Complete software supply chain security for the software you
                  build, buy and deploy.
                </p>
                {isDemoPortal ? <RegisterUserLink /> : <MailToSupportLink />}
              </div>
            </div>
          </div>
          <div className={styles["grid-col"]}>
            <div className={styles["content-wrapper"]}>{children}</div>
          </div>
        </div>
      </div>
      {/* Toast container needs to be within react router component so router links will work in toasts */}
      <Toast.Container />
    </div>
  );
};

export default LoginLayout;
